export default __webpack_public_path__ + "static/media/logoReact.849bf6c6.png";